<template>
    <zen-slide-in
        :isOpen="isOpen"
        title="Invite user"
        :error="error"
        @close="$emit('close')"
    >
        <template #body>
            <div class="space-y-1 mb-6">
                <p class="text-sm text-taupe-600">
                    Invite a new user to join your team. They will receive a
                    welcome email with instructions to set up their account.
                </p>
            </div>

            <div class="space-y-5">
                <!-- Name fields grouped -->
                <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
                    <div>
                        <label
                            for="user-first-name"
                            class="block text-sm font-medium leading-6 text-taupe-900"
                        >
                            First name
                            <span class="text-red-500">*</span>
                        </label>
                        <div class="mt-2">
                            <input
                                type="text"
                                name="user-first-name"
                                id="user-first-name"
                                :value="data.first_name"
                                @input="
                                    $emit('update:data', {
                                        ...data,
                                        first_name: $event.target.value,
                                    })
                                "
                                placeholder="John"
                                class="block w-full rounded-md border-0 py-2 px-3 text-taupe-900 shadow-sm ring-1 ring-inset ring-taupe-300 placeholder:text-taupe-400 focus:ring-2 focus:ring-inset focus:ring-sky-600 sm:text-sm sm:leading-6 transition-shadow"
                            />
                        </div>
                    </div>
                    <div>
                        <label
                            for="user-last-name"
                            class="block text-sm font-medium leading-6 text-taupe-900"
                        >
                            Last name
                            <span class="text-red-500">*</span>
                        </label>
                        <div class="mt-2">
                            <input
                                type="text"
                                name="user-last-name"
                                id="user-last-name"
                                :value="data.last_name"
                                @input="
                                    $emit('update:data', {
                                        ...data,
                                        last_name: $event.target.value,
                                    })
                                "
                                placeholder="Smith"
                                class="block w-full rounded-md border-0 py-2 px-3 text-taupe-900 shadow-sm ring-1 ring-inset ring-taupe-300 placeholder:text-taupe-400 focus:ring-2 focus:ring-inset focus:ring-sky-600 sm:text-sm sm:leading-6 transition-shadow"
                            />
                        </div>
                    </div>
                </div>

                <!-- Email -->
                <div>
                    <label
                        for="user-email"
                        class="block text-sm font-medium leading-6 text-taupe-900"
                    >
                        Email address
                        <span class="text-red-500">*</span>
                    </label>
                    <div class="mt-2">
                        <input
                            type="email"
                            name="user-email"
                            id="user-email"
                            :value="data.email"
                            @input="
                                $emit('update:data', {
                                    ...data,
                                    email: $event.target.value,
                                })
                            "
                            placeholder="john.smith@example.com"
                            class="block w-full rounded-md border-0 py-2 px-3 text-taupe-900 shadow-sm ring-1 ring-inset ring-taupe-300 placeholder:text-taupe-400 focus:ring-2 focus:ring-inset focus:ring-sky-600 sm:text-sm sm:leading-6 transition-shadow"
                        />
                    </div>
                    <p class="mt-1.5 text-xs text-taupe-500">
                        This email will be used for login and notifications.
                    </p>
                </div>

                <!-- Marketing emails -->
                <div class="relative flex gap-x-3 items-start pt-2 pb-1">
                    <div class="flex h-6 items-center">
                        <input
                            type="checkbox"
                            name="newsletter"
                            id="newsletter"
                            :checked="data.allow_marketing_emails"
                            @change="
                                $emit('update:data', {
                                    ...data,
                                    allow_marketing_emails:
                                        $event.target.checked,
                                })
                            "
                            class="h-4 w-4 rounded border-taupe-300 text-sky-600 focus:ring-sky-600 transition-colors"
                        />
                    </div>
                    <div class="text-sm leading-6">
                        <label
                            for="newsletter"
                            class="font-medium text-taupe-900"
                            >Subscribe to newsletter</label
                        >
                        <p class="text-taupe-500 text-xs mt-0.5">
                            Send occasional updates and tips. User can
                            unsubscribe anytime.
                        </p>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:buttons>
            <zen-button
                variant="secondary"
                size="medium"
                @click="$emit('close')"
            >
                Cancel
            </zen-button>
            <zen-button
                variant="primary"
                size="medium"
                :processing="processing"
                :disabled="!canSubmit"
                @click="$emit('confirm')"
            >
                Send Invitation
            </zen-button>
        </template>
    </zen-slide-in>
</template>

<script>
export default {
    name: 'InviteUserSlideIn',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        },
        error: {
            type: [String, Object],
            default: null,
        },
        canSubmit: {
            type: Boolean,
            default: false,
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'confirm', 'update:data'],
}
</script>
